<template>
  <div>
    <div class="bgfff">
        <div class="topheader clearfix">
            <div class="topClass fl"><span @click="openWindow(host+'lesson/list.html')">全部课程</span></div>
            <div class="topClassInf fl" style="width: 650px"><span>课程数量：<em class="c-red">{{allClassNum}}节</em></span><span>名师：<em class="c-red">{{allTeacherNum}}人</em></span><span>学习人数：<em class="c-red">{{allBuyNum}}人</em></span><span>好评：<em class="c-red">{{allGoodCommentNum}}条</em></span></div>
            <!-- <div class="topClassCop fr ffff2020"><img :src="img"><a href="javascript:void (0);" target="_self" @click="openWindow(host+'specials/ffff2020/jz.html')"></a><a href="javascript:void (0);" target="_self" @click="openWindow(host+'specials/ffff2020/zq.html')"></a></div> -->
        </div>
    </div>
  <banner></banner>
  <tree></tree>
    <div class="w1180 bgfff mt20">
        <!--div class="prcdiv clearfix">
            <dl class="dl001 clearfix" onclick="javascript:window.open('//caidao.homeway.com.cn/lesson/free.html')">
                <dt><span class="sp1"></span> </dt>
                <dd><h1>免费体验</h1><p>新手免费体验</p></dd>
            </dl>
            <span class="line2"></span>
            <dl class="dl001 clearfix" onclick="javascript:window.open('//caidao.homeway.com.cn/lesson/begin.html')">
                <dt><span class="sp2"></span> </dt>
                <dd><h1>入门精选</h1><p>炒股基本课程精选</p></dd>
            </dl>
            <span class="line2"></span>
            <dl class="dl001 clearfix" onclick="javascript:window.open('//caidao.homeway.com.cn/lesson/middle.html')">
                <dt><span class="sp3"></span> </dt>
                <dd><h1>进阶战法</h1><p>高手进阶养成计划</p></dd>
            </dl>
            <span class="line2"></span>
            <dl class="dl001 clearfix" onclick="javascript:window.open('//caidao.homeway.com.cn/lesson/list.html')">
                <dt><span class="sp4"></span> </dt>
                <dd><h1>其它课程</h1><p>更多经典理论课程</p></dd>
            </dl>
        </div-->
    </div>
    <lesson lesstype='ggk'></lesson>
    <div class="w1180 ggdiv"><a :href="fotbanlink" target="_blank"><img :src="fotban"></a></div>
    <lesson lesstype='tsk'></lesson>
  </div>
</template>
<style>
  @import '//imgcd.homeway.com.cn/lesson/css/style.css';
  /*@import 'http://test.caidao.hexun.com/lesson/css/style.css';*/
  /*@import './assets/web/css/style.css';*/
  @import './assets/web/css/styleindex.css';
  .ffff2020{
    position: relative;
  }
  .ffff2020 a{
    display: inline-block;
    height: 50px;
    position: absolute;
    top:0;
  }
  .ffff2020 a:nth-child(2){
    width: 148px;
    left:0;
  }
  .ffff2020 a:nth-child(3){
    width: 156px;
    right:0;
  }
</style>
<script>
import banner from '@/components/banner'
import tree from '@/components/tree'
import lesson from '@/components/lesson'
export default {
  name: 'MainPage',
  components:{
    banner,
    tree,
    lesson
  },
  data () {
    return {
      msg: '首页模版',
      allClassNum:0,
      allTeacherNum:0,
      allBuyNum:0,
      allGoodCommentNum:0,
      fotban:'',
      fotbanlink:'',
      host:'//'+(window.location.host.match('test')?'test':'')+'caidao.homeway.com.cn/',
      // img:'//'+(window.location.host.match('test')?'testcaidao':'imgcd')+'.homeway.com.cn/lesson/images/bantxt.jpg'
    }
  },
  methods:{
      openWindow:function(_url){
        window.open(_url||this.host);
      },
      bindtot:function(){
        var _this = this,type=0;
            var posturl = _this.apilist.homestatistics;
            _this.getData(posturl,function(data){
              if(data.code=='0')
              {
                _this.allClassNum = data.data.allClassNum;
                _this.allTeacherNum = data.data.allTeacherNum;
                _this.allBuyNum = data.data.allBuyNum;
                _this.allGoodCommentNum = data.data.allGoodCommentNum;
              }
            })
            _this.getData(_this.apilist.banner+'11/1/1',function(data){
              if(data.code=='0')
              {
              _this.fotban = data.data.list[0].imageUrl;
              _this.fotbanlink=data.data.list[0].link;
              }
            })
      }
    },
    mounted(){
      this.bindtot()
    },
}
</script>



// WEBPACK FOOTER //
// App.vue?4dfdaa9c